var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 13.333,
    viewBox: "0 0 10 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M73.722,5h-.833V3.889a3.889,3.889,0,0,0-7.778,0V5h-.833A.278.278,0,0,0,64,5.278v6.944a1.112,1.112,0,0,0,1.111,1.111h7.778A1.112,1.112,0,0,0,74,12.222V5.278A.278.278,0,0,0,73.722,5Zm-3.89,5.8a.278.278,0,0,1-.276.308H68.444a.278.278,0,0,1-.276-.308l.175-1.576a1.1,1.1,0,0,1-.455-.894,1.111,1.111,0,1,1,2.222,0,1.1,1.1,0,0,1-.455.894ZM71.222,5H66.778V3.889a2.222,2.222,0,1,1,4.444,0Z",
    transform: "translate(-64)",
    fill: "#bd1f60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.da918c1d7fc9e654a22fc20de06afeb3.svg";
export { ForwardRef as ReactComponent };